import styled from 'styled-components';

import { Form } from '@components/form';
import { DynamicFields, FormV2 } from '@components/form/v2';
import { Stack } from '@components/stack';
import { Text } from '@components/text';
import { useScopedTranslate } from '@locale/translate';

export const SubmissionSuccess = ({
  submissionMessageConfig,
}: {
  submissionMessageConfig?: FormV2;
}) => {
  const { t } = useScopedTranslate(translations);
  return (
    <Container>
      {submissionMessageConfig ? (
        <Form space={6} onSubmit={() => {}}>
          <DynamicFields fields={submissionMessageConfig.fields} />
        </Form>
      ) : (
        <>
          <Text font="heading2" text={t('title')} />
          <Text font="regular16" text={t('body')} />
        </>
      )}
    </Container>
  );
};

const translations = {
  en: {
    title: 'Form received',
    body: 'Thank you for taking the time to complete this important form. We will contact you if we feel we need more information.',
  },
  is: {
    title: 'Svör móttekin',
    body: 'Takk fyrir að taka þér tíma til að fylla út þetta mikilvæga form. Við höfum samband ef við teljum okkur þurfa fleiri upplýsingar.',
  },
};

const Container = styled(Stack).attrs({ space: 4 })({
  textAlign: 'center',
  margin: 'auto',
  width: '100%',
  padding: '2.5rem',
  maxWidth: '35rem',
});
